export default "__VITE_ASSET__DRqyfJQx__"